module.exports = __webpack_public_path__ + "img/logo_rarible.91ff19e6.png";